<template>
  <div class="roots">
    <client-only>
      <BrandUpgradeNoticeBar />
    </client-only>
    <Nuxt />
    <client-only>
      <CookieActionSheet :cookieList="cookieList" />
      <template v-if="isMobile && !isApp">
        <component
          :is="tabbarComp"
          v-show="showTabbar()"
          :tabbarList="tabbarList"
          @beforeChange="beforeChange"
          v-model="active"
        />
      </template>
      <LandscapeGuide />
    </client-only>
  </div>
</template>

<script>
  import { mapGetters, mapState, mapMutations } from 'vuex'
  import { region } from '@/utils/utils'
  import { LanguageIsoMap } from '@/config/sitemap'
  import { ROUTE_FIX } from '@/config/routePrefix'
  import { getLocation } from '@/utils/ssrCompatible'
  import { session } from '@/utils/storage'
  import { COOKIE_TYPE } from '@/utils/cookieUtils'
  import CookieActionSheet from '@/components/CookieActionSheet'
  import { pageListener } from '@/utils/pageListener'
  import { checkoutTokenCountry } from '@/utils/login/index'
  import {
    registerAppShow,
    registerAppUserExpOptiChanged,
  } from '@/utils/native'
  import TabBar from './TabBar.vue'
  import TabBar2 from './TabBar2.vue'
  import { getVersion } from '@/utils/toplupeVersion'
  import LandscapeGuide from '@/components/LandscapeGuide'
  import BrandUpgradeNoticeBar from '@/components/BrandUpgradeNoticeBar'
  import { isShowLandscapeGuide, allInputBlur } from '@/utils/utils'
  import { getCurrentPage } from '@/utils/utils.js'

  const icons = {
    home: {
      black: require(`@/assets/images/common/tabbar/home.png`),
      silvery: require(`@/assets/images/common/tabbar/silvery-home.png`),
      white: require(`@/assets/images/common/tabbar/white-home.png`),
      'orange-filled': require(`@/assets/images/common/tabbar/home-1.png`),
    },
    order: {
      black: require(`@/assets/images/common/tabbar/order.png`),
      silvery: require(`@/assets/images/common/tabbar/silvery-order.png`),
      white: require(`@/assets/images/common/tabbar/white-order.png`),
      'orange-filled': require(`@/assets/images/common/tabbar/order-1.png`),
    },
    about: {
      black: require(`@/assets/images/common/tabbar/about.png`),
      silvery: require(`@/assets/images/common/tabbar/silvery-about.png`),
      white: require(`@/assets/images/common/tabbar/white-about.png`),
      'orange-filled': require(`@/assets/images/common/tabbar/about-1.png`),
    },
  }

  export default {
    name: 'Default',
    components: {
      CookieActionSheet,
      TabBar,
      TabBar2,
      LandscapeGuide,
      BrandUpgradeNoticeBar,
    },
    head() {
      return {
        htmlAttrs: {
          lang: LanguageIsoMap[region()] || 'en',
        },
      }
    },
    data() {
      return {
        active: 0,
        loginStatus: false,
        showLoginBtn: false,
        cookieList: [
          {
            type: COOKIE_TYPE.ESSENTIAL,
          },
          {
            type: COOKIE_TYPE.ANALYTICAL,
            isShow: true,
          },
          {
            type: COOKIE_TYPE.ADVERTISING,
            isShow: true,
          },
        ],
        allowShow: true,
      }
    },
    computed: {
      ...mapState([
        'isMobile',
        'userInfo',
        'isTurbo',
        'isApp',
        'gameName',
        'isInPubgmGameApp',
        'isDesktop',
        'region',
        'showLandscapeGuide',
        'i18nMessages',
      ]),
      ...mapGetters(['displayMobile', 'isNew', 'displayHorizontal']),
      tabbarComp() {
        return this.isNew ? 'TabBar2' : 'TabBar'
      },
      tabbarList() {
        const { path: pathname } = session.get('_location') || this.$route
        const res = ROUTE_FIX.some((item) => pathname.indexOf(item) !== -1)
        const lastIndex = pathname.lastIndexOf('/') >= 3
        let fix = ''

        if (lastIndex) {
          fix = res ? `${pathname.slice(0, 3)}` : ''
        } else {
          const result = ROUTE_FIX.some((item) => pathname === item)

          if (result) {
            fix = res ? `${pathname.slice(0, 3)}` : ''
          }
        }

        const homePath = `${fix}/`
        const orderPath = `${fix}/order`
        const aboutPath = `${fix}/about`

        const { inactive, active } = this.getIconColor()
        let icon = {}
        const tabKeyArr = ['home', 'order', 'about']
        tabKeyArr.forEach((key) => {
          icon[key] = {
            inactive: icons[key][inactive],
            active: icons[key][active],
          }
        })

        const result = [
          {
            id: 'home',
            to: homePath,
            icon: {
              active: icon['home'].active,
              inactive: icon['home'].inactive,
            },
            title: this.$t('common.home'),
          },
          {
            id: 'order',
            to: orderPath,
            icon: {
              active: icon['order'].active,
              inactive: icon['order'].inactive,
            },
            title: this.$t('common.order'),
          },
          {
            id: 'about',
            to: aboutPath,
            icon: {
              active: icon['about'].active,
              inactive: icon['about'].inactive,
            },
            title: this.$t('common.about'),
          },
        ]

        return result
      },
      canShowLandscapeGuide() {
        return isShowLandscapeGuide({
          gameName: this.gameName,
          isInPubgmGameApp: this.isInPubgmGameApp,
          isDesktop: this.isDesktop,
          isTurbo: this.isTurbo,
          region: this.region,
          isApp: this.isApp,
        })
      },
    },
    created() {
      if (!process.client) return
      const language =
        (Object.keys(this.i18nMessages).length &&
          Object.keys(this.i18nMessages)) ||
        ''
      if (language) {
        this.$root.$i18n.setLocaleMessage(language, this.i18nMessages[language])
      }
      const data = {
        pathname: this.$route.path,
        ...this.$route,
      }
      session.set('_location', data)

      if (this.isApp) {
        registerAppShow()
        registerAppUserExpOptiChanged()
      }

      if (!(this.isDesktop || this.isTurbo || this.isApp)) {
        window.addEventListener('orientationchange', this.changeOrientation)
      }
    },
    mounted() {
      // 初始化版本
      this.setLayoutVersion(getVersion())
      if (this.displayHorizontal) {
        // 横屏适配
        document.documentElement.style.width = '100%'
      }
      pageListener(() => {
        checkoutTokenCountry()
      })
      const timeid = setTimeout(() => {
        window.__ksui__ &&
          window.__ksui__.loading &&
          window.__ksui__.loading.hide()
        clearTimeout(timeid)
      }, 100)

      this.active = this.defaultActive()
    },
    beforeDestroy() {
      window.removeEventListener('orientationchange', this.changeOrientation)
    },
    watch: {
      userInfo(data) {
        if (data && data.kicoinId && data.kicoinToken) {
          this.loginStatus = true
        }
      },
      $route(val, oldVal) {
        this.active = this.defaultActive()
        const { path: currentPath } = val
        const { path: prevPath } = oldVal
        const currentPage = getCurrentPage(currentPath)
        const prevPage = getCurrentPage(prevPath)
        const mainPage = ['home', 'order', 'about']
        if (mainPage.includes(currentPage) && mainPage.includes(prevPage)) {
          this.allowShow = true
        } else if (
          mainPage.includes(currentPage) &&
          !mainPage.includes(prevPage)
        ) {
          // 这儿的逻辑是为了从其它页面跳转回首页的时候，导航栏不会先显示出来
          this.allowShow = false
          const timer = setTimeout(
            () => ((this.allowShow = true), clearTimeout(timer)),
            800
          )
        } else {
          this.allowShow = false
        }
      },
      // 横屏时使键盘消失
      showLandscapeGuide(val) {
        if (val) {
          allInputBlur()
        }
      },
      // 监听多个state值
      canShowLandscapeGuide(val) {
        this.setShowLandscapeGuide(val)
      },
    },
    methods: {
      ...mapMutations(['setLayoutVersion', 'setShowLandscapeGuide']),
      // 刷新默认选中
      defaultActive() {
        const { pathname } = getLocation()
        const checkPath = ['order', 'about']

        const isContain = checkPath.some(
          (item) => pathname.indexOf(item) !== -1
        )

        if (isContain) {
          let result = checkPath.findIndex(
            (item) => pathname.indexOf(item) !== -1
          )
          return result + 1
        }

        return 0
      },
      showTabbar() {
        const { name } = this.$route
        const { pathname } = getLocation()
        const showPath = ['/', '/home', '/order', '/about']
        const isWithfix = ROUTE_FIX.some((item) => pathname.startsWith(item))
        let isShowPath = true

        // todo 时间紧急、之后会优化
        if (isWithfix) {
          if (pathname.length > 4) {
            isShowPath = showPath.includes(pathname.slice(3))
          }
        } else {
          isShowPath = showPath.includes(pathname)
        }
        return (
          name && this.isMobile && isShowPath && !this.isTurbo && this.allowShow
        )
      },
      login(data) {
        if (data.status * 1 === 0) {
          this.loginStatus = false
        } else {
          this.loginStatus = true
        }
      },
      beforeChange(index) {
        if (index * 1 === 1 && !this.loginStatus) {
          this.$refs.loginBtn && this.$refs.loginBtn.loginBtn()
          this.showLoginBtn = true
        }
        return true
      },
      getIconColor() {
        const layoutVersion = getVersion()
        if (layoutVersion === 'version-2-2') {
          return {
            inactive: 'black',
            active: 'white',
          }
        } else if (this.isNew) {
          return {
            inactive: 'silvery',
            active: 'white',
          }
        } else {
          return {
            inactive: 'black',
            active: 'orange-filled',
          }
        }
      },
      changeOrientation() {
        setTimeout(() => {
          let show = isShowLandscapeGuide({
            gameName: this.gameName,
            isInPubgmGameApp: this.isInPubgmGameApp,
            isDesktop: this.isDesktop,
            isTurbo: this.isTurbo,
            region: this.region,
            isApp: this.isApp,
          })
          this.setShowLandscapeGuide(show)
        }, 100)
      },
    },
  }
</script>
